//@ts-nocheck
import { px2remTransformer, StyleProvider } from '@ant-design/cssinjs'
import { useData } from '@pn/components/src/utils/hooks'
import { keepPreviousData, QueryClient, QueryClientProvider, useQuery, useMutation } from '@tanstack/react-query'
import { Toast, Space, SpinLoading, ErrorBlock } from 'antd-mobile'
import React, { StrictMode, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { getUserInfo, login } from '@/services/index'
import useAppContext from '@/useAppContext'
import App from './App'
import dayjs from 'dayjs'
import getUrlQuery from '@/utils/getUrlQuery'
import GlobalQueryProvider from "./GlobalQueryProvider";


import './styles.less'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 600 * 1, // 数据垃圾回收时间 默认 1000 * 60 * 5 5分钟
      staleTime: 600 * 1, // 重新获取数据的时间间隔 默认0
      retry: 2, // 失败重试次数 默认 3次
      refetchOnWindowFocus: false, // 窗口获得焦点时重新获取数据
      placeholderData: keepPreviousData,
      // keepPreviousData: false,
      //   retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
})
const px2rem = px2remTransformer({
  rootValue: 100, // 1rem = 100px
});

const Root = () => {

  const initValue = {
    token: getUrlQuery('token') || localStorage.getItem('token'),
    user: {},
    isLogin: false,
    loading: false,
    error: false,
    noauth: false,
  }
  const [data, setData] = useData(initValue);
  const { token, error, loading } = data

  //登录
  const mutationLogin = useMutation({
    mutationFn: login,
    onSuccess: (res: any) => {
      const { token } = res.data
      localStorage.setItem('token', token)
      setData({ token, loading: false })
    },
    onError: (msg: string) => {
      setData({ token: null, loading: false })
    },
  })

  const validateToken = useMutation({
    mutationFn: getUserInfo,
    onSuccess: (res: any) => {
      if (res.success) {
        setData({ loading: false, error: false, user: res.data })
      } else {
        setData({ token: null, loading: false, error: false })
        localStorage.removeItem('token');
      }
    },
    onError: (error: Error) => {
      Toast.show({
        icon: 'fail',
        content: error || error.msg || error.message,
      });
      if (error == "token无效") {
        Toast.show({
          icon: 'fail',
          content: 'token无效请重新登录',
        });
        return
      }
      if (error == "租户越权访问") {
        return
      }
      //mutationLogin.mutate({ phone: '13101096677', password: '12345678' })
      setData({ token: null, loading: true, error: false });
      localStorage.removeItem('token');
    },
  });
  useEffect(() => {
    if (!token) {
      setData({ loading: true });
      //mutationLogin.mutate({ phone: '13101096677', password: '12345678' });
    } else {
      setData({ loading: true });

      validateToken.mutate({});
    }
  }, [token]);

  if (loading) {
    return (
      <Space
        direction='vertical'
        align='center'
        justify='center'
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ color: '#1890ff', textAlign: 'center', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <SpinLoading color='primary' />
          <span style={{ fontSize: '14px', marginTop: 5, display: 'block' }}>页面加载中...</span>
        </div>
      </Space>
    )
  }

  if (error) {
    return (
      <Space
        direction='vertical'
        align='center'
        justify='center'
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ color: '#ff4d4f', textAlign: 'center', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <ErrorBlock status='disconnected' description="页面出错，请刷新重试" />
        </div>
      </Space>
    )
  }

  let context = { context: data, dispatch: setData }
  return (
    <StrictMode>
      <StyleProvider transformers={[px2rem]}>
        <useAppContext.Provider value={context}>
          <App />
        </useAppContext.Provider>
      </StyleProvider>
    </StrictMode>
  )
}

const PageRoot = () => {
  return <>
    <QueryClientProvider client={queryClient}>
      <Root />
    </QueryClientProvider>
  </>
}

ReactDOM.createRoot(document.getElementById('root')!).render(<PageRoot />)
